import {IStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getRankingsState = ({ranking}: IStore) => ranking;

export const getRankings = createSelector(getRankingsState, (ranking) => ranking.rankings);

export const getLoadingState = createSelector(getRankingsState, ({requestState}) => requestState);

export const getCurrentPage = createSelector(getRankingsState, ({currentPage}) => currentPage);

export const getNextPage = createSelector(getRankingsState, ({next}) => next);
